export const FALLBACK_ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const DEFAULT_ERROR_PAGE_TITLE = 'Invalid session';
export const LOGGED_IN_ERROR_PAGE_TITLE = 'Log in re-attempt';

export const errors = {
  passwordNotMatch: { message: 'Passwords do not match. Please try again.' },
  weakPassword: { message: 'Password is not secure enough.' },
  passwordMatchGTM: { message: 'passwords do not match.' },
  weakPasswordGTM: { message: 'password is not secure enough.' },
  resetPasswordGTM: { message: 'error resetting password.' },
  setPasswordGTM: { message: 'error creating new password.' },
  invalidEmail: { message: 'Invalid email.' },
  invalidPhone: { message: 'Invalid phone number.' },
  invalidName: { message: 'Invalid name.' },
  invalidNameLetters: { message: 'Name must contain letters.' },
  invalidNameLength: {
    message: 'Name must be between 1-30 characters including spaces.',
  },
  invalidNameCharacters: {
    message: 'Name must only contain letters, hyphens, and apostrophes.',
  },
  invalidPostcode: { message: 'Invalid UK postcode.' },
  requiredField: { message: 'This field is required.' },
  invalidOwnersPostcodeLength: {
    message: 'Postcode must be between 1-8 characters including spaces.',
  },
  invalidOwnerAccountNumber: {
    message: 'Invalid owner account number. Required format is AA000000.',
  },
  invalidResetPasswordToken: {
    message:
      'Your password reset token is invalid or has expired. Please submit a new request to reset your password.',
    showCallCenter: true,
  },
  invalidSetPasswordToken: {
    message: 'Your set password token is invalid or has expired. Please try again.',
    showCallCenter: true,
  },
  invalidAddressLine: { message: 'Invalid address line.' },
  invalidCity: { message: 'Invalid city.' },
  invalidCounty: { message: 'Invalid county.' },
  defaultError: {
    message: 'Sorry but we have encountered an error, please try again in a few minutes.',
    showCallCenter: true,
    showResetPassword: false,
  },
};

export const callCenters = {
  haven: {
    message: 'If the problem persists call the Contact Centre on ',
    number: '0333 202 5250',
  },
  owners: {
    message: 'If the problem persists please contact your Park team.',
    number: '',
  },
};

export const passwordReset = {
  message:
    'If you remember your password, just pop over to the login page to continue. Otherwise, simply ',
  passwordResetText: 'reset your password.',
  passwordResetLink: '/forgot-password',
};

export const initialErrorState = {
  message: '',
  showCallCenter: false,
  showResetPassword: false,
  clientId: '',
};
